/**
 * @classdesc - グッズのスライド
 */

import gsap from 'gsap';


export default class ImgSlide {
    constructor() {
        this._init();
    }

    _init() {
        this.thumbnails = document.querySelectorAll('.js-goods__thumb img');

        this.thumbnails.forEach(thumbnail => {
            thumbnail.addEventListener('click', (event) => {
                this._handleThumbnailClick(event);
            });
        });
    }

    _handleThumbnailClick(event) {
        const newSrc = event.target.src;

        // 対象のメイン画像を見つけてsrcを差し替え
        const closestGoodsItem = event.target.closest('.goods-item');
        const mainImage = closestGoodsItem.querySelector('.js-goods-item__img');
        mainImage.src = newSrc;

        // サムネイルの -current クラスを更新
        const thumbnails = closestGoodsItem.querySelectorAll('.js-goods__thumb');
        thumbnails.forEach(thumbnail => {
            thumbnail.classList.remove('-current');
        });
        event.target.closest('.js-goods__thumb').classList.add('-current');

        gsap.set(mainImage, {scale:1.1});
        gsap.to(mainImage, {scale:1, duration:0.5, ease:'power2.out'});
    }
}